function setTheCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
    
function getTheCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseTheCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

 //Motivator Product JS Start
var motivatorProduct = false;
document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.classList.contains('click_gift')) {
      var isChecked = target.checked;
      if(isChecked){
        eraseTheCookie("Shipping_protection")
      }
      else{
        setTheCookie("Shipping_protection", 1)
      }
      fetch('/cart.json')
        .then(response => response.json())
        .then(data => {
          var items = data.items;
          var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
          if (isChecked && !foundMotivatorProduct) {
            addMotivatorProduct(motivatorProductVariantID);
          } else if (!isChecked) {
            removeMotivatorProduct(motivatorProductVariantID);
          }
          // target.closest('.cart_loading').classList.add('cart_loading');
        });
    }
  });

  function cartItemCheck() {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        var items = data.items;
        if (items.length > 1) {
          removeMotivatorProduct(motivatorProductVariantID);
          document.querySelector('.click_gift').checked = false;
        }
      });
  }

  function initMotivatorProduct() {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        var items = data.items;
        var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
        if (!foundMotivatorProduct) {
          addMotivatorProduct(motivatorProductVariantID);
        }
      });
  }
});



function addMotivatorProduct(variantID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
    var sections_url = window.location.pathname;
    $('#CartDrawer-Checkout').attr('disabled',true)
    // Send request to add item to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": 1, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
      cartDrawer.open();
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      $(".click_gift").prop("checked", true);
        $('#CartDrawer-Checkout').attr('disabled',false)
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  }


// function removeMotivatorProduct(variantID) {
//     // Open the cart drawer
//     var cartDrawer = document.querySelector('cart-drawer');
//     var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
//     var sections_url = window.location.pathname;
//     // Send request to add item to cart
//     fetch("/cart/change.js", {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ "quantity": 0, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url})
//     })
//     .then(response => response.json())
//     .then(response => {
//       cartDrawer.renderContents(response);
      
//       // if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
//         $(".click_gift").prop("checked", false);
//     })
//     .catch(error => {
//         console.error("Error remove item to cart:", error);
//     });
//   }
function removeMotivatorProduct(variantID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
    var sections_url = window.location.pathname;
      $('#CartDrawer-Checkout').attr('disabled',true)
    // Send request to remove item from cart
    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": 0, "id": variantID, "sections": sectionsToRender, "sections_url": sections_url })
    })
    .then(response => response.json())
    .then(response => {
        cartDrawer.renderContents(response);
        cartDrawer.open();
        if (response.items.length === 0) {
            cartDrawer.classList.add('is-empty');
        }
        $(".click_gift").prop("checked", false);
        $('#CartDrawer-Checkout').attr('disabled',false)
    })
    .catch(error => {
        console.error("Error removing item from cart:", error);
    });
}




function shippingProtection() {
    var variantID = motivatorProductVariantID;
  
    var motivatorProduct = false;
    $.ajax({
     type: 'GET',
     url: '/cart.json',
     dataType: 'jsonp',
     success: function(data) {
       var items = data['items'];
       var itemsValue = data['items_subtotal_price'];
       for (var i = 0; i < items.length; i++) {
         // console.log(`Item Data = ${items[i]["id"]}`);
         if (items[i]["id"] == motivatorProductVariantID) {
           motivatorProduct = true;
           
           console.log('motivatorProductVariantID', motivatorProductVariantID)
           console.log('items[i]["id"]',items[i]["id"])
           console.log(motivatorProduct)
           
           
         }
       }
        var FreeVariantID = '50211476635929';
    var hasFreeVariantProduct = items.some(item => item["id"] == FreeVariantID);
       if(items.length === 1){
         if(motivatorProduct) {
           removeMotivatorProduct(variantID);
           console.log('items.length === 1')
         }
       }
       if(items.length > 0){
         if(!motivatorProduct && !getTheCookie("Shipping_protection")) {
           addMotivatorProduct(variantID);
           console.log('items.length > 0')
         }
          else if (items.length == 2 && hasFreeVariantProduct && motivatorProduct) {
            var removeCounter = 0;
            var removeinterval = setInterval(function() {
              removeCounter++;
              if(motivatorProductVariantID) {
                removeMotivatorProduct(variantID);
                clearInterval(removeinterval);
              }
              if(removeCounter > 10 ) {
                clearInterval(removeinterval);
              }
            }, 2000);
           
           console.log('cookie else')
         }
        
       } else{
         removeMotivatorProduct(variantID);
         console.log('! items.length > 0')
       }
       
     }
    });
  }

$(document).ready(function(){
  

if (window.location.href.includes('/cart')) {
    shippingProtection();
}
 

  $('button[data-pf-type="ProductATC2"]').click(function(){
   
    var counter = 0;
    var FreeCounter = 0;
    var interval = setInterval(function() {
      counter++;
      if($("button[data-pf-type='ProductATC2']").length) {
        shippingProtection();
        clearInterval(interval);
      }
      if(counter > 10 ) {
        clearInterval(interval);
      }
    }, 2000);

     var Freeinterval = setInterval(function() {
      FreeCounter++;
      if($("button[data-pf-type='ProductATC2']").length) {
        FreeProduct();
        clearInterval(Freeinterval);
      }
      if(FreeCounter > 10 ) {
        clearInterval(Freeinterval);
      }
    }, 1000);
  });
})
//Motivator Product JS END


// Upsell Add to cart
$(document).on("change",'#variant_selector',function(){
  var dataSelect = $(this).val();
 var dataImg = $(this).find("option:selected").data("img");
  $(this).parents('.upsell_product_variant_add').find('.upsell_product_add').attr('data-variantid',dataSelect);
  $(this).parents('.upsell_product_item').find('.upsell_media_img').attr("src", dataImg);
});

$(document).on("click",".ajax-add-to-cart",function() {
     $(this).addClass("btn--loading");
    var ajaxVariantID = $(this).attr('data-variantId');
    addToCartJS(ajaxVariantID,$(this));
  });

function addToCartJS(variantID, $btn) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": 1, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
      cartDrawer.open();
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
       $btn.removeClass("btn--loading");
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  }


 //Free Product JS Start

document.addEventListener('DOMContentLoaded', function () {
  var freeProduct = false;
var FreevariantID = '50211476635929';
  
});

  function FreeProduct() {
    var FreevariantID = '50211476635929';
  
    var freeProduct = false;
    
    $.ajax({
     type: 'GET',
     url: '/cart.json',
     dataType: 'jsonp',
     success: function(data) {
       var items = data['items'];
       
       var itemsValue = data['items_subtotal_price'];
       for (var i = 0; i < items.length; i++) {
         // console.log(`Item Data = ${items[i]["id"]}`);
         if (items[i]["id"] == FreevariantID) {
           freeProduct = true;
           
           console.log('freeProduct', FreevariantID)
           console.log('items[i]["id"]',items[i]["id"])
           console.log(FreevariantID)
           
           
         }

         
       }
         // var motivatorProductVariantID = motivatorProductVariantID;
         
         var hasMotivatorProduct = items.some(item => item["id"] == motivatorProductVariantID);

       if(items.length === 1){
         if(freeProduct) {
           removeFreeProduct(FreevariantID);
           console.log('Free items.length === 1')
         }
       }
       if(items.length > 0 ){
         if(!freeProduct) {
           addFreeProduct(FreevariantID);
           console.log('Free items.length > 0')
         }
         else if (items.length == 2 && freeProduct && hasMotivatorProduct) {
           removeFreeProduct(FreevariantID);
           console.log('Free cookie else')
         }
        
       } else{
         removeFreeProduct(FreevariantID);
         console.log('Free ! items.length > 0')
       }
      
      
     }
    });
  }

function addFreeProduct(FreevariantID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
    var sections_url = window.location.pathname;
    $('#CartDrawer-Checkout').attr('disabled',true)
    // Send request to add item to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": 1, "id": FreevariantID, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
      cartDrawer.open();
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        $('#CartDrawer-Checkout').attr('disabled',false)
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  }


  
  
  function removeFreeProduct(FreevariantID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
    var sections_url = window.location.pathname;
      $('#CartDrawer-Checkout').attr('disabled',true)
    // Send request to remove item from cart
    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": 0, "id": FreevariantID, "sections": sectionsToRender, "sections_url": sections_url })
    })
    .then(response => response.json())
    .then(response => {
        cartDrawer.renderContents(response);
        cartDrawer.open();
        if (response.items.length === 0) {
            cartDrawer.classList.add('is-empty');
        }
        $('#CartDrawer-Checkout').attr('disabled',false)
    })
    .catch(error => {
        console.error("Error removing item from cart:", error);
    });
}

 console.log(window.location.href)
  if (window.location.href.includes('/products/free-flyhugz®-ebook-tips-to-travelers-in-2025')) {
    window.location.href = '/collections/all';
  }

$(document).ready(function(){
  $('.logo_slider_wrapper').slick({
    slidesToShow: 9,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 500,
    arrows: false, 
    dots: false,
    responsive: [
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 992, 
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 360, 
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  
});



document.querySelectorAll(".button_redirect").forEach(button => {
    button.addEventListener("click", function() {
        if (window.innerWidth >= 768) { 
            document.querySelector("#main__product__section").scrollIntoView({ behavior: "smooth" });
        } else { 
            document.querySelector(".thumbnail-slider").scrollIntoView({ behavior: "smooth" });
        }
    });
});



document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href === 'https://flyhugz.com/collections/all' || 
      window.location.href === 'https://flyhugz.com/collections') {

        var metaTag = document.createElement('meta');
        metaTag.name = "robots";
        metaTag.content = "noindex, nofollow";
        document.head.appendChild(metaTag);
    
       window.location.href = 'https://flyhugz.com/';
  }
});



// Bundle Variant Functionlity
$('.bundle_item').click(function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    if($(this).hasClass('bundle_buy_1')){
      $('product-form form input[name="items[0][id]"]').attr('disabled', true);
      var bundleCheckedVariant = $(this).find('.color-swatch-option').val(); 
      $('product-form form input[name="id"]').val(bundleCheckedVariant);
    }
    else{
      $('product-form form input[name="items[0][id]"]').attr('disabled', false);
      var bundleCheckedVarOne = $(this).find('.Bundle-variant-1 .color-swatch-option').val(); 
      var bundleCheckedVarTwo = $(this).find('.Bundle-variant-2 .color-swatch-option').val(); 
      $('product-form form input[name="id"]').val(bundleCheckedVarOne);
      $('product-form form input[name="items[0][id]"]').val(bundleCheckedVarTwo);
    }
    
});

$('.bundle_buy_1 .Bundle-variant-1 .color-swatch-option').change(function() {
    var bundleBuyOne = $(this).val(); 
    $('product-form form input[name="id"]').val(bundleBuyOne);
    var bundleChecked = $(this).find('option:checked');  
    var selectedSwatch = bundleChecked.data('variant-color');
    $(this).siblings('.bundle-variant-color').css('background',selectedSwatch);
    var dataImg = bundleChecked.data('variant-img');
    $('.product__media-list').find('.product__media-item:first-child img').attr('src',dataImg);
    $('.product__media-list').find('.product__media-item:first-child img').attr('srcset',dataImg);
});

$('.bundle_buy_2 .Bundle-variant-1 .color-swatch-option').change(function() {
    var bundleBuyTwoOne = $(this).val(); 
    $('.product-form form input[name="id"]').val(bundleBuyTwoOne);
    var bundleChecked = $(this).find('option:checked'); 
    var selectedSwatch = bundleChecked.data('variant-color');
    $(this).siblings('.bundle-variant-color').css('background',selectedSwatch);
    var dataImg = bundleChecked.data('variant-img');
    $('.product__media-list').find('.product__media-item:first-child img').attr('src',dataImg);
    $('.product__media-list').find('.product__media-item:first-child img').attr('srcset',dataImg);
});


$('.bundle_buy_2 .Bundle-variant-2 .color-swatch-option').change(function() {
    var bundleBuyTwoTwO = $(this).val(); 
    $('product-form form input[name="items[0][id]"]').val(bundleBuyTwoTwO);
    var bundleChecked = $(this).find('option:checked');  
    var selectedSwatch = bundleChecked.data('variant-color');
    $(this).siblings('.bundle-variant-color').css('background',selectedSwatch);
    var dataImg = bundleChecked.data('variant-img');
    $('.product__media-list').find('.product__media-item:first-child img').attr('src',dataImg);
    $('.product__media-list').find('.product__media-item:first-child img').attr('srcset',dataImg);
});




